<h3>
  {{
    queryName ? ("QUERY.TITLE" | translate) : ("QUERY.TITLE_NEW" | translate)
  }}
  {{ queryName }}
</h3>
<p-confirmDialog></p-confirmDialog>
<div class="query-name-container">
  <div class="main-data">
    <label for="queryName">{{ "QUERY.EXPORT_NAME" | translate }} </label>
    <div class="query-name-input">
      <input
        id="queryName"
        type="text"
        pInputText
        [(ngModel)]="queryName"
        [autofocus]="true"
      />
      <small class="error">{{ getErrorMessage("queryName") }}</small>
    </div>
    <div class="form-field">
      <label for="selLaboratorio">{{ "QUERY.LAB_TYPE" | translate }}</label>
      <p-dropdown
        id="selLaboratorio"
        [options]="laboratoryTypes"
        optionValue="id"
        optionLabel="description"
        [showClear]="false"
        appendTo="body"
        [(ngModel)]="selectedLabType"
        (ngModelChange)="onSelectedLabTypeChanged()"
      >
      </p-dropdown>
    </div>
    <div class="form-field">
      <p-checkbox
        id="demographicDataOnly"
        [(ngModel)]="demographicDataOnly"
        [binary]="true"
        [label]="'QUERY.DEMOGRAPHIC_DATA_ONLY' | translate"
        inputId="demographicDataOnly"
        (ngModelChange)="onDemographicDataOnlyChanged()"
      ></p-checkbox>
    </div>
    <div class="form-field" *ngIf="showHistoricalDataCheckbox">
      <p-checkbox
        id="includeHistoricalData"
        [(ngModel)]="includeHistoricalData"
        [binary]="true"
        [label]="'QUERY.INCLUDE_HISTORICAL_DATA' | translate"
        inputId="includeHistoricalData"
      ></p-checkbox>
    </div>
  </div>

  <div class="botonera">
    <p-button
      label="{{ 'QUERY.EXPORT' | translate }}"
      (click)="submit()"
      *ngIf="showCrearExport"
    ></p-button>
    <p-button
      label="{{ 'QUERY.SHOW_RESULTS' | translate }}"
      (click)="showResults()"
      *ngIf="showQuerySave"
    ></p-button>
    <p-button label="{{ 'SAVE' | translate }}" (click)="save()"></p-button>
  </div>
</div>

<div class="container">
  <div>
    <h4>{{ "QUERY.BASIC_PARAMS" | translate }}</h4>
    <div class="basic-container">
      <form [formGroup]="form">
        <div class="form-basic">
          <div class="form-field">
            <label for="registerRange">{{
              "QUERY.I_FECHA_REGISTRO_RANGE" | translate
            }}</label>
            <p-calendar
              dateFormat="dd/mm/yy"
              inputId="registerRange"
              formControlName="registerRange"
              selectionMode="range"
              [readonlyInput]="true"
              [firstDayOfWeek]="1"
              [showClear]="true"
            ></p-calendar>
          </div>

          <div class="form-field">
            <label for="registerRange">{{
              "PATIENT_DATA.EDAD" | translate
            }}</label>
            <div class="edad-container">
              <p-inputNumber
                class="age-input"
                inputId="ageTo"
                formControlName="ageTo"
                placeholder="desde"
              ></p-inputNumber>
              <p-inputNumber
                class="age-input"
                inputId="ageFrom"
                formControlName="ageFrom"
                placeholder="hasta"
              ></p-inputNumber>
            </div>
          </div>

          <div class="form-field">
            <label for="reasonRequest">{{
              "QUERY.I_MOTIVO_SOLICITUD" | translate
            }}</label>
            <input
              id="reasonRequest"
              type="text"
              pInputText
              formControlName="reasonRequest"
            />
          </div>

          <div class="form-field">
            <label for="validationRange">{{
              "QUERY.D_FECHA_VALIDACION_DT_RANGE" | translate
            }}</label>
            <p-calendar
              dateFormat="dd/mm/yy"
              inputId="validationRange"
              formControlName="validationRange"
              selectionMode="range"
              [readonlyInput]="true"
              [showClear]="true"
            ></p-calendar>
          </div>

          <div class="form-field">
            <label for="selGender">{{ "QUERY.PA_SEXO" | translate }}</label>

            <p-dropdown
              id="selGender"
              [options]="genders"
              formControlName="gender"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selUrgent">{{ "QUERY.I_URGENTE" | translate }}</label>

            <p-dropdown
              id="selUrgent"
              [options]="urgencies"
              formControlName="urgent"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selCenter">{{
              "QUERY.CEN_DESC_L_CENTRO" | translate
            }}</label>

            <p-dropdown
              id="selCenter"
              [options]="centers$ | async"
              formControlName="centerId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selService">{{
              "QUERY.S_NOMBRE_SERVICIO" | translate
            }}</label>

            <p-dropdown
              id="selService"
              [options]="services$ | async"
              formControlName="serviceId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selTarget">{{
              "QUERY.DES_DESC_DESTINO" | translate
            }}</label>

            <p-dropdown
              id="selTarget"
              [options]="targets$ | async"
              formControlName="targetId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selDiagnosis">{{
              "QUERY.DIAG_DESC_L_DIAGNOSTICO" | translate
            }}</label>

            <p-dropdown
              id="selDiagnosis"
              [options]="diagnosis$ | async"
              formControlName="diagnosisId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selArea">{{
              "QUERY.A_DESC_L_AREAS" | translate
            }}</label>

            <p-dropdown
              id="selArea"
              [options]="areas$ | async"
              formControlName="areaId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selLab">{{
              "REQUEST_DATA.LABORATORIO" | translate
            }}</label>

            <p-dropdown
              id="selLab"
              [options]="labs$ | async"
              formControlName="labId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="selTipoPeticion">{{
              "QUERY.TIPO_PETICION" | translate
            }}</label>

            <p-dropdown
              id="selTipoPeticion"
              [options]="tiposPeticion$ | async"
              formControlName="tipoPeticionId"
              [filter]="true"
              optionValue="id"
              optionLabel="description"
              [showClear]="true"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="form-field">
            <label for="comment">{{ "QUERY.COMMENT" | translate }}</label>
            <input
              id="comment"
              type="text"
              pInputText
              formControlName="comment"
            />
          </div>

          <div class="form-field">
            <label for="validationRangeEpisode">{{
              "QUERY.VALIDATION_RANGE_EPISODE" | translate
            }}</label>
            <p-calendar
              dateFormat="dd/mm/yy"
              inputId="validationRangeEpisode"
              formControlName="validationRangeEpisode"
              selectionMode="range"
              [readonlyInput]="true"
            ></p-calendar>
          </div>

          <div class="form-field">
            <label for="episode">{{ "QUERY.EPISODE" | translate }}</label>
            <input
              id="episode"
              type="text"
              pInputText
              formControlName="episode"
            />
          </div>

          <div class="form-field">
            <label for="priority">{{ "QUERY.PRIORITY" | translate }}</label>
            <input
              id="priority"
              type="text"
              pInputText
              formControlName="priority"
            />
          </div>

          <div class="form-field">
            <label for="target">{{
              "QUERY.DES_DESC_DESTINO" | translate
            }}</label>
            <input
              id="target"
              type="text"
              pInputText
              formControlName="target"
            />
          </div>

          <div class="form-field">
            <label for="externalSystem">{{
              "QUERY.EXTERNAL_SYSTEM" | translate
            }}</label>
            <input
              id="externalSystem"
              type="text"
              pInputText
              formControlName="externalSystem"
            />
          </div>

          <div class="form-field">
            <label for="info9">{{ "QUERY.I_INFO_9" | translate }}</label>
            <input id="info9" type="text" pInputText formControlName="info9" />
          </div>

          <div class="form-field">
            <label for="notesHCIS">{{
              "QUERY.EXTERNAL_OBSERVATIONS" | translate
            }}</label>
            <input
              id="notesHCIS"
              type="text"
              pInputText
              formControlName="notesHCIS"
            />
          </div>

          <div class="form-field">
            <label for="extractor">{{ "QUERY.EXTRACTOR" | translate }}</label>
            <input
              id="extractor"
              type="text"
              pInputText
              formControlName="extractor"
            />
          </div>

          <div class="form-field">
            <label for="appointments">{{
              "QUERY.APPOINTMENTS_NUMBER" | translate
            }}</label>
            <input
              id="appointments"
              type="text"
              pInputText
              formControlName="appointments"
            />
          </div>

          <div class="form-field">
            <label for="hcisUnity">{{ "QUERY.HCIS_UNITY" | translate }}</label>
            <input
              id="hcisUnity"
              type="text"
              pInputText
              formControlName="hcisUnity"
            />
          </div>
        </div>
        <div class="query-builder-container" *ngIf="config$ | async as config">
          <h4>
            {{
              (isGeneralLab ? "QUERY.METHODS" : "QUERY.SAMPLE_TYPE") | translate
            }}
          </h4>
          <p-multiSelect
            *ngIf="isGeneralLab"
            [options]="methods"
            [placeholder]="'QUERY.METHODS' | translate"
            optionLabel="label"
            optionValue="value"
            [virtualScroll]="true"
            formControlName="methods"
            [virtualScrollItemSize]="20"
            class="method-selector"
            [showClear]="true"
          ></p-multiSelect>
          <div class="form-field strict-method-match-field" *ngIf="isGeneralLab">
            <p-checkbox
              id="strictMethodMatch"
              formControlName="strictMethodMatch"
              [binary]="true"
              [label]="'QUERY.STRICT_METHOD_MATCH' | translate"
              inputId="strictMethodMatch"
            ></p-checkbox>
          </div>
          <p-multiSelect
            *ngIf="isMicroLab"
            [options]="materials"
            [placeholder]="'QUERY.SAMPLE_TYPE' | translate"
            optionLabel="label"
            optionValue="value"
            [virtualScroll]="true"
            formControlName="methods"
            [virtualScrollItemSize]="20"
            class="method-selector"
            [showClear]="true"
          ></p-multiSelect>
        </div>
        <div class="query-builder-container" *ngIf="config$ | async as config">
          <h4>{{ "QUERY.FIELDS" | translate }}</h4>
          <p-multiSelect
            [options]="fieldOptions"
            defaultLabel="{{ 'ALL_MALE' | translate }}"
            formcon
            optionLabel="description"
            optionValue="id"
            [virtualScroll]="true"
            [virtualScrollItemSize]="20"
            class="method-selector"
            [showClear]="true"
            formControlName="fields"
          ></p-multiSelect>
        </div>
        <div class="query-builder-container">
          <h4>{{ "QUERY.NUM_PETICION" | translate }}</h4>
          <p-chips
            class="num-peticion-selector"
            separator=","
            formControlName="numPeticion"
            [max]="10000"
          />
          <app-csv-chip-loader
            [type]="'PETICIONES'"
            [queryName]="queryName"
            [hasExistingData]="(form.get('numPeticion')?.value || []).length > 0"
            [loadedCount]="loadedPeticionesCount"
            (valuesLoaded)="onPeticionesLoaded($event)"
            (loadError)="onPeticionesLoadError($event)"
            (cleared)="clearPeticionesValues()"
          ></app-csv-chip-loader>
        </div>
        <div class="query-builder-container">
          <h4>{{ "QUERY.COD_PATIENT" | translate }}</h4>
          <p-chips
            class="num-peticion-selector"
            separator=","
            formControlName="codPatient"
            [max]="10000"
          />
          <app-csv-chip-loader
            [type]="'NHC'"
            [queryName]="queryName"
            [hasExistingData]="(form.get('codPatient')?.value || []).length > 0"
            [loadedCount]="loadedNhcCount"
            (valuesLoaded)="onNhcLoaded($event)"
            (loadError)="onNhcLoadError($event)"
            (cleared)="clearNhcValues()"
          ></app-csv-chip-loader>
        </div>
      </form>
    </div>
  </div>

  <div class="query-builder-container" *ngIf="config$ | async as config">
    <h4>{{ "QUERY.RESULTS" | translate }}</h4>
    <afoone-query-builder-output
      [rulesetObservable$]="ruleset$"
    ></afoone-query-builder-output>

    <ngx-condition-builder
      [config]="config"
      [(ngModel)]="ruleset"
      (ngModelChange)="conditionChanged($event)"
    >
    </ngx-condition-builder>
  </div>
</div>
